var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelope = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 2.90625 0.875 2 2 2H14C15.0938 2 16 2.90625 16 4V12C16 13.125 15.0938 14 14 14H2C0.875 14 0 13.125 0 12V4ZM1.5 4V4.71875L6.875 9.125C7.53125 9.65625 8.4375 9.65625 9.09375 9.125L14.5 4.71875V4C14.5 3.75 14.25 3.5 14 3.5H2C1.71875 3.5 1.5 3.75 1.5 4ZM1.5 6.65625V12C1.5 12.2812 1.71875 12.5 2 12.5H14C14.25 12.5 14.5 12.2812 14.5 12V6.65625L10.0625 10.2812C8.84375 11.2812 7.125 11.2812 5.90625 10.2812L1.5 6.65625Z",
    fill: "#404040"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelope);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDIuOTA2MjUgMC44NzUgMiAyIDJIMTRDMTUuMDkzOCAyIDE2IDIuOTA2MjUgMTYgNFYxMkMxNiAxMy4xMjUgMTUuMDkzOCAxNCAxNCAxNEgyQzAuODc1IDE0IDAgMTMuMTI1IDAgMTJWNFpNMS41IDRWNC43MTg3NUw2Ljg3NSA5LjEyNUM3LjUzMTI1IDkuNjU2MjUgOC40Mzc1IDkuNjU2MjUgOS4wOTM3NSA5LjEyNUwxNC41IDQuNzE4NzVWNEMxNC41IDMuNzUgMTQuMjUgMy41IDE0IDMuNUgyQzEuNzE4NzUgMy41IDEuNSAzLjc1IDEuNSA0Wk0xLjUgNi42NTYyNVYxMkMxLjUgMTIuMjgxMiAxLjcxODc1IDEyLjUgMiAxMi41SDE0QzE0LjI1IDEyLjUgMTQuNSAxMi4yODEyIDE0LjUgMTJWNi42NTYyNUwxMC4wNjI1IDEwLjI4MTJDOC44NDM3NSAxMS4yODEyIDcuMTI1IDExLjI4MTIgNS45MDYyNSAxMC4yODEyTDEuNSA2LjY1NjI1WiIgZmlsbD0iIzQwNDA0MCIvPgo8L3N2Zz4K";